import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const InstitutionHeader = ({ institution }) => {
  return (
    <div className="bg-card rounded-lg shadow-warm-sm border border-border overflow-hidden">
      <div className="relative h-48 md:h-64 lg:h-80 bg-gradient-to-br from-primary/20 to-secondary/20">
        <Image
          src={institution?.coverImage}
          alt={institution?.coverImageAlt}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
      </div>
      <div className="p-4 md:p-6 lg:p-8">
        <div className="flex flex-col lg:flex-row gap-4 md:gap-6 lg:gap-8">
          <div className="flex-shrink-0">
            <div className="w-20 h-20 md:w-24 md:h-24 lg:w-32 lg:h-32 bg-white rounded-lg shadow-warm p-2 md:p-3 -mt-12 md:-mt-16 lg:-mt-20 border-4 border-card">
              <Image
                src={institution?.logo}
                alt={institution?.logoAlt}
                className="w-full h-full object-contain"
              />
            </div>
          </div>

          <div className="flex-1 min-w-0">
            <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-3 md:gap-4">
              <div className="flex-1 min-w-0">
                <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground mb-2">
                  {institution?.name}
                </h1>
                <div className="flex flex-wrap items-center gap-2 md:gap-3 text-sm md:text-base text-muted-foreground mb-3 md:mb-4">
                  <div className="flex items-center gap-1.5">
                    <Icon name="MapPin" size={16} color="var(--color-primary)" />
                    <span className="font-caption">{institution?.location}</span>
                  </div>
                  <span className="hidden md:inline">•</span>
                  <div className="flex items-center gap-1.5">
                    <Icon name="Calendar" size={16} color="var(--color-primary)" />
                    <span className="font-caption">Est. {institution?.established}</span>
                  </div>
                  <span className="hidden md:inline">•</span>
                  <div className="flex items-center gap-1.5">
                    <Icon name="Award" size={16} color="var(--color-accent)" />
                    <span className="font-caption font-medium">{institution?.ranking}</span>
                  </div>
                </div>

                <div className="flex flex-wrap gap-2">
                  {institution?.badges?.map((badge, index) => (
                    <span
                      key={index}
                      className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary/10 text-primary rounded-md text-xs md:text-sm font-caption font-medium"
                    >
                      <Icon name={badge?.icon} size={14} />
                      {badge?.label}
                    </span>
                  ))}
                </div>
              </div>

              <div className="flex md:flex-col gap-2 md:gap-3">
                <button className="flex items-center justify-center gap-2 px-4 py-2 bg-muted hover:bg-muted/80 rounded-md transition-smooth">
                  <Icon name="Share2" size={18} color="var(--color-foreground)" />
                  <span className="text-sm font-caption font-medium hidden md:inline">Share</span>
                </button>
                <button className="flex items-center justify-center gap-2 px-4 py-2 bg-muted hover:bg-muted/80 rounded-md transition-smooth">
                  <Icon name="Bookmark" size={18} color="var(--color-foreground)" />
                  <span className="text-sm font-caption font-medium hidden md:inline">Save</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 lg:gap-6 mt-6 md:mt-8 pt-6 md:pt-8 border-t border-border">
          {institution?.stats?.map((stat, index) => (
            <div key={index} className="text-center md:text-left">
              <div className="flex items-center justify-center md:justify-start gap-2 mb-1.5 md:mb-2">
                <Icon name={stat?.icon} size={20} color="var(--color-primary)" />
                <p className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-foreground data-text">
                  {stat?.value}
                </p>
              </div>
              <p className="text-xs md:text-sm text-muted-foreground font-caption">
                {stat?.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InstitutionHeader;